import NoteModal from './Note';

export default NoteModal;
